import React from 'react';
import { Modal } from '@components';
import TableConectoresRelacionados from './TableConectoresRelacionados';

export default function ModalConectoresRelacionados({ data, visible, onOk }) {
  const handleOk = () => {
    onOk();
  };

  const handleCancel = () => {
    onOk();
  };

  return (
    <Modal visible={visible} onCancel={handleCancel} onOk={handleOk} title='Conectores relacionados'>
      <TableConectoresRelacionados data={data} />
    </Modal>
  );
}
